import React, { useState } from "react";
import { Expand } from "lucide-react";
import Lightbox from "./Lightbox";
import { Reveal, SectionHeading } from "./Common";

// A reusable zoomable gallery grid used across collection pages.
const GallerySection = ({ eyebrow, title, accent, images = [], label }) => {
  const [box, setBox] = useState({ open: false, index: 0 });

  return (
    <section className="py-24 bg-noir-2 border-y border-[var(--line)]">
      <div className="max-w-[1360px] mx-auto px-6 md:px-10">
        <Reveal><SectionHeading eyebrow={eyebrow} title={title} accent={accent} align="center" /></Reveal>
        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {images.map((img, i) => (
            <Reveal key={i} delay={i * 70}>
              <button
                onClick={() => setBox({ open: true, index: i })}
                className={`img-zoom relative w-full h-56 group ${i === 0 ? "md:col-span-2 md:h-auto lg:col-span-2" : ""}`}
                aria-label={`Open image ${i + 1}`}
              >
                <img src={img} alt={`${label || title} ${i + 1}`} className="w-full h-full object-cover" />
                <span className="absolute inset-0 bg-[rgba(14,58,43,0)] group-hover:bg-[rgba(14,58,43,0.35)] transition-colors flex items-center justify-center">
                  <span className="opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-2 text-[var(--cream)] text-xs tracking-[0.16em] uppercase border border-[rgba(245,240,230,0.5)] px-4 py-2">
                    <Expand size={14} /> Zoom
                  </span>
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <Lightbox
        open={box.open}
        images={images}
        index={box.index}
        title={label || title}
        onClose={() => setBox({ ...box, open: false })}
      />
    </section>
  );
};

export default GallerySection;
